import React, {createContext, useReducer} from 'react'
import {CHOOSE_TYPE} from '../types/Type'
import {typeReducer} from '../reducer/typeReducer'
import ContextDevTool from 'react-context-devtool';


export const TypeContext = createContext();

const init = {
       select: {selectedType: ''}
}

const TypeContextProvider = (props) => {
    const [stateType, dispatch] = useReducer(typeReducer , init)

    const  selectType = (type) => {
        dispatch({
            type: CHOOSE_TYPE,
            payload: {select: {selectedType: type}}
        })
    }

    return(
        <TypeContext.Provider 
            value={{
                stateType,
                selectType
                }}>
        <ContextDevTool context={TypeContext} id="TypeContext" displayName="TypeContext" />
            {props.children}
        </TypeContext.Provider>
    )
}

export default TypeContextProvider